/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosError } from "axios";
// import { readToken } from "./services/localStorage.service";
import { notificationController } from "components/Common/Notification/Notification";

let authorizationToken: string | null = null;
const AuthToken = sessionStorage.getItem("AuthToken");

/** @param Authentication api call */
const input = `${process.env.REACT_APP_API_DOMAIN_NAME}|${process.env.REACT_APP_API_DOMAIN_KEY}`;
const base64String = btoa(input);

export const setAuthToken = (auth: string) => {
  authorizationToken = auth;
};

export interface ApiResponse<T> {
  data: T;
}

export interface ApiErrorData {
  message: string;
}

export const httpApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
httpApi.interceptors.request.use((config: any) => {
  config.headers = {
    ...config.headers,
    Authorization: `Basic ${base64String}`,
    Token: AuthToken ? AuthToken : authorizationToken,
  };
  return config;
});

export const httpApiArtifi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
httpApiArtifi.interceptors.request.use((config: any) => {
  config.headers = {
    ...config.headers,
    Authorization: `Basic ${base64String}`,
  };
  return config;
});

httpApi.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response) {
      const errorData = error.response.data as { ErrorMessage?: string; Message?: string };

      if (error.response.status === 401) {
        const errorMessage = errorData.ErrorMessage || "Unauthorized access";
        notificationController.error({
          message: errorMessage,
        });
      } else if (error.response.status === 500) {
        const errorMessage = errorData.ErrorMessage
          ? errorData.ErrorMessage
          : errorData.Message || "An unexpected server error occurred";
        notificationController.error({
          message: errorMessage,
        });
      }
    }
    // Always reject the promise if there's an error
    return Promise.reject(error);
  }
);
